import React from 'react';
import PersonalInfoStore from './PersonalInfoStore';
import PersonalInfoActions from './PersonalInfoActions';
import {TextField, SelectField} from '../../FormFields/formFields';
import HeaderActions from '../../Header/HeaderActions';


export default class PersonalInfo extends React.Component {
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.canSubmit = this.canSubmit.bind(this);
        this.afterSubmit = this.afterSubmit.bind(this);
        this.state = PersonalInfoStore.getState();
    }

    componentWillMount() {
        let days = [],
			years = [],
			d,
			y,
			date= new Date(),
			thisYear= date.getFullYear(),
			targetYear= thisYear - 100;
        for(d = 1; d <= 31; d++) {
            days.push({day: d});
        }
        for(y = thisYear; y >= targetYear; y--) {
            years.push({year: y});
        }
        this.setState({
            phoneTypes: [
                //{type: window.jenkon.resources['PWS.MyAccount.PhoneTypeHome'] },
                {type: window.jenkon.resources['PWS.MyAccount.PhoneTypeMobile'], code: 'MOBILE'},
                {type: window.jenkon.resources['PWS.MyAccount.PhoneTypeFax'], code: 'FAX'}
            ],
            primaryPhoneTypes: [
                {type: window.jenkon.resources['PWS.MyAccount.PhoneTypeHome'], code: 'HOME'},
            ],
            genders: [
                {value: 'Male', displayValue: window.jenkon.resources['PWS.MyAccount.GenderMale']},
                {value: 'Female', displayValue: window.jenkon.resources['PWS.MyAccount.GenderFemale']}
            ],
            years: years,
            months: [
				{name: 'Jan', value: '01'},
				{name: 'Feb', value: '02'},
				{name: 'Mar', value: '03'},
				{name: 'Apr', value: '04'},
				{name: 'May', value: '05'},
				{name: 'Jun', value: '06'},
				{name: 'Jul', value: '07'},
				{name: 'Aug', value: '08'},
				{name: 'Sep', value: '09'},
				{name: 'Oct', value: '10'},
				{name: 'Nov', value: '11'},
				{name: 'Dec', value: '12'}
            ],
            days: days,
        });
    }

    componentDidMount() {
        PersonalInfoStore.listen(this.onChange);
        PersonalInfoActions.getCountriesCultures();
    }

    componentWillUnmount() {
        PersonalInfoStore.unlisten(this.onChange);
    }

    canSubmit() {
        return this.refs.firstName.isValid() &&
            this.refs.lastName.isValid() &&
            this.refs.email.isValid() &&
			this.refs.homePhoneNumber.isValid() &&
			this.refs.mobilePhoneNumber.isValid() &&
            this.isEmailValid();
    }

    registerErrors() {
        this.refs.firstName.registerErrors();
        this.refs.lastName.registerErrors();
        this.refs.email.registerErrors();
        this.refs.homePhoneNumber.registerErrors();
        this.refs.mobilePhoneNumber.registerErrors();
        this.isEmailValid();
    }

    onChange(state) {
        this.setState(state);
    }

    isEmailValid() {
        return !this.state.emailExists;
    }

    onEmailBlur(value) {
        if (window.jenkon.AllowDuplicateEmailAddresses === 'False')
        {
            if (this.state.originalState && this.state.originalState.email !== value) {
                PersonalInfoActions.validateEmail(value, window.jenkon.country, window.jenkon.CustomerAccountType);
            }
            else
                PersonalInfoActions.emailSuccess(true);
        }
    }

    cancelChanges() {
        PersonalInfoActions.cancelChanges();
        this.props.setView();
    }

    saveChanges() {
        if (this.canSubmit()) {
            let lang = this.state.languageList.filter(l => l.languageCode == this.state.language);
           //console.log(lang)
            let personalInfoData = {
                AccountCode: this.state.accountCode,
                Name: `${this.state.firstName} ${this.state.lastName}`,
                FirstName: this.state.firstName,
                LastName: this.state.lastName,
                Email: this.state.email,
				HomePhoneNumber: this.state.homePhoneNumber,
				HomePhoneNumberType: this.state.homePhoneNumberType,
                MobilePhoneNumber: this.state.mobilePhoneNumber,
                MobilePhoneNumberType: this.state.mobilePhoneNumberType,
                OptOut: this.state.emailOptOut,
                BirthDate: this.state.BirthMonth + '/' + this.state.BirthDay + '/' + this.state.BirthYear,
                Culture: lang[0].code,
                Gender: this.state.gender,
                UserName: this.state.userName
            };
            PersonalInfoActions.submitChanges(personalInfoData, this.afterSubmit);


        } else {
            this.registerErrors();
        }
    }

    afterSubmit() {
        if (!this.props.showUserName) {
            if (this.state.email != this.state.userName)
                HeaderActions.logout();
        }
        else
            this.props.setView;
    }

    render() {
        let emailErrorDisplay = this.state.emailExists ? <div className="login-error-message">{window.jenkon.resources["PWS.Enrollment.EmailAddressExistsMessage"]}</div> : '';
        if (this.state.homePhoneNumberType == null) this.state.homePhoneNumberType = "HOME";
        if (this.state.mobilePhoneNumberType == null) this.state.mobilePhoneNumberType = "MOBILE";
        let phoneHomeVal = this.state.phoneFormats.find(item => {return item.typeCode.toUpperCase() === 'HOME'});
        let phoneMobileVal = this.state.phoneFormats.find(item => {return item.typeCode.toUpperCase() === 'MOBILE'});


        let validationRules = {
            FirstName: {
                required: true,
                requiredMessage: window.jenkon.resources['PWS.MyAccount.FirstNameRequiredMessage']
            },
            LastName: {
                required: true,
                requiredMessage: window.jenkon.resources['PWS.MyAccount.LastNameRequiredMessage']
            },
            PrimaryPhone: {
                enrollmentPhone: typeof phoneHomeVal === 'undefined' ? '' : phoneHomeVal.format,
                enrollmentPhoneMessage:  window.jenkon.resources['PWS.MyAccount.PersonalInfoPhoneNumberInvalidFormat']
            },
            MobilePhone: {
                enrollmentPhone: typeof phoneMobileVal === 'undefined' ? '' : phoneMobileVal.format,
                enrollmentPhoneMessage:  window.jenkon.resources['PWS.MyAccount.PersonalInfoPhoneNumberInvalidFormat']
            },
            Email: {
                required: true,
                requiredMessage: window.jenkon.resources['PWS.MyAccount.EmailAddressRequiredMessage'],
                email: true,
                emailMessage: window.jenkon.resources['PWS.MyAccount.EmailAddressInvalidMessage']
            },
        };

        let keys = {
            primaryPhoneType: {
                valueKey: 'code',
                nameKey: 'type'
            },
            phoneType: {
                valueKey: 'code',
                nameKey: 'type'
            },
            gender: {
                valueKey: 'gender',
                nameKey: 'displayValue'
            },
            months: {
                valueKey: 'value',
                nameKey: 'name'
            },
            days: {
                valueKey: 'day',
                nameKey: 'day'
            },
            years: {
                valueKey: 'year',
                nameKey: 'year'
            },
        };

        return (
            <div className="personalInfoFormWrapper clearfix">
                    <div className="col-md-6">
                        <TextField
        ref="firstName"
        name="firstName"
        handleChange={PersonalInfoActions.changeField}
        Rules={validationRules.FirstName}
        value={this.state.firstName}
        label={window.jenkon.resources['PWS.MyAccount.PersonalInfoFirstName']}
        classes="input-bordered input-100"
    />
    <TextField
        ref="lastName"
        name="lastName"
        Rules={validationRules.LastName}
        value={this.state.lastName}
        handleChange={PersonalInfoActions.changeField}
        label={window.jenkon.resources['PWS.MyAccount.PersonalInfoLastName']}
        classes="input-bordered input-100"
    />
    <TextField
        ref="homePhoneNumber"
        name="homePhoneNumber"
        handleChange={PersonalInfoActions.changeField}
        Rules={validationRules.PrimaryPhone}
        value={this.state.homePhoneNumber}
        label={window.jenkon.resources['PWS.MyAccount.PersonalInfoPhoneNumber']}
        classes="input-bordered input-50"
    />
    <SelectField
        ref="primaryPhoneType"
        name="homePhoneNumberType"
        handleChange={PersonalInfoActions.changeField}
        optionData={this.state.primaryPhoneTypes}
        keys={keys.primaryPhoneType}
        showEmptyOption={false}
        value={this.state.homePhoneNumberType}
        label={window.jenkon.resources['PWS.MyAccount.PhoneType']}
        classes="input-bordered input-50"
    />
    <TextField
        ref="mobilePhoneNumber"
        name="mobilePhoneNumber"
        handleChange={PersonalInfoActions.changeField}
        Rules={validationRules.MobilePhone}
        value={this.state.mobilePhoneNumber}
        label={window.jenkon.resources['PWS.MyAccount.PersonalInfoMobilePhoneNumber']}
        classes="input-bordered input-50"
    />
    <SelectField
        ref="phoneType"
        name="mobilePhoneNumberType"
        handleChange={PersonalInfoActions.changeField}
        optionData={this.state.phoneTypes}
        keys={keys.phoneType}
        showEmptyOption={false}
        value={this.state.mobilePhoneNumberType}
        label={window.jenkon.resources['PWS.MyAccount.PhoneType']}
        classes="input-bordered input-50"
    />
    <SelectField
        ref="BirthYear"
        name="BirthYear"
        handleChange={PersonalInfoActions.changeField}
        optionData={this.state.years}
        keys={keys.years}
        value={this.state.BirthYear}
        label={window.jenkon.resources["PWS.Enrollment.BirthdateYear"]}
        classes="input-bordered input-25"
    />
    <SelectField
        ref="BirthMonth"
        name="BirthMonth"
        handleChange={PersonalInfoActions.changeField}
        optionData={this.state.months}
        keys={keys.months}
        value={this.state.BirthMonth}
        label={window.jenkon.resources["PWS.Enrollment.BirthdateMonth"]}
        classes="input-bordered input-25"
    />
    <SelectField
        ref="BirthDay"
        name="BirthDay"
        handleChange={PersonalInfoActions.changeField}
        optionData={this.state.days}
        keys={keys.days}
        value={this.state.BirthDay}
        label={window.jenkon.resources["PWS.Enrollment.BirthdateDay"]}
        classes="input-bordered input-25"
    />

    <div className="visuallyhidden">
        <SelectField
            ref="gender"
            name="gender"
            handleChange={PersonalInfoActions.changeField}
            optionData={this.state.genders}
            keys={keys.gender}
            value={this.state.gender}
            label={window.jenkon.resources['PWS.MyAccount.Gender']}
            classes="input-bordered input-50"
        />
    </div>

</div>
<div className="col-md-6 col-xs-12">
{emailErrorDisplay}
<TextField
        ref="email"
        name="email"
        handleChange={PersonalInfoActions.changeField}
        Rules={validationRules.Email}
        value={this.state.email}
        label={window.jenkon.resources['PWS.MyAccount.PersonalInfoEmailAddress']}
        classes="input-bordered input-100"
        handleBlur={this.onEmailBlur.bind(this)}
    />
    <div className="input-100 visuallyhidden">
        <input id="EmailOptOut" name="EmailOptOut" type="checkbox" checked={this.state.emailOptOut} onChange={PersonalInfoActions.changeField.bind(this, 'emailOptOut', !this.state.emailOptOut)}/>
        &nbsp;&nbsp;&nbsp;<label htmlFor="EmailOptOut">{window.jenkon.resources["PWS.MyAccount.EmailOptOut"]}</label>
    </div>
    <label>Language</label>
    <div className="input-100 ">
        <SelectField
        ref="customerLanguage"
        handleChange={PersonalInfoActions.changeField}
        optionData={this.state.languageList}
        value={this.state.language}
        keys={{valueKey: 'languageCode', nameKey: 'language'}}
        name="language"
        label={window.jenkon.resources["PWS.MyAccount.Language"]}
        />
    </div>

    {this.props.showUserName &&
        <div>
            <div className="input-100 clearfix" >
                <label>{window.jenkon.resources['PWS.MyAccount.UserName']}</label>
                <div className="input-100">
                    <TextField
                        ref="userName"
                        name="userName"
                        disabled={true}
                        value={this.state.userName}
                        label={window.jenkon.resources['PWS.MyAccount.Username']}
                        classes="input-bordered input-50"
                    />
                </div>
            </div>
            <div className="input-50 clearfix">
                <button className="bg-primary" onClick={this.props.changeView.bind(this, 'Username')}>{window.jenkon.resources['PWS.MyAccount.ChangeUsername']}</button>
            </div>
        </div>
    }
<div className="input-100">
    <button onClick={this.props.changeView.bind(this, 'Password')} className="bg-primary">{window.jenkon.resources['PWS.MyAccount.ChangePassword']}</button>
</div>
</div>
<div className="col-md-6 col-xs-12">
    <button className="pull-left basic-submit-button" onClick={this.cancelChanges.bind(this)}>{window.jenkon.resources['PWS.Globals.CancelButton']}</button>
    <button className="pull-left basic-submit-button" onClick={this.saveChanges}>{window.jenkon.resources['PWS.Globals.SaveChangesButton']}</button>
</div>
</div>
        );
}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/PersonalInfo/PersonalInfo.js